import { useRouter } from "next/router";
import axios from "axios";
import styles from "./article.module.scss";
import Head from "next/head";
import Breadcrumbs from "../../components/blog/breadcrumbs/breadcrumbs";
import Image from "next/image";
import BlogLayout from "../../components/blog_layout";

export default function Article({ articleInfo }) {
	const router = useRouter();
	const { article, category, title, header, date, description } = articleInfo.attributes;
	const pageLink = `https://bgrem.ai${router.asPath}`;
	function transformDate(d) {
		const date = new Date(d);
		const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		let month = "" + months[date.getMonth()];
		let day = "" + date.getDate();
		let year = "" + date.getFullYear().toString().slice(-2);

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return `${month} ${day}, ${year}`;
	}
	const articleDate = transformDate(date);
	const categoryName = category.data.attributes.name;

	const canonical = `https://bgrem.ai${router.asPath}`;

	const imgRegExp = /\<img/g;

	return (
		<BlogLayout mainClassName="blog">
			<Head>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:type" content="article" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
				<meta property="og:url" content={`https://bgrem.ai${router.asPath}`} />
				<meta property="og:image" content={articleInfo.attributes.cover_image.data.attributes.url} />
				<meta property="og:site_name" content="bgrem" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:section" content="blog" />
				<meta property="og:published_time" content={date} />
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:image:src" content={articleInfo.attributes.cover_image.data.attributes.url} />
				<link rel="canonical" href={canonical} />
			</Head>
			<Breadcrumbs categoryName={categoryName} articleTitle={title} />
			<section className={styles.container}>
				<div className={styles["container-content"]}>
					<h1 className={styles.title}>{header ? header : title}</h1>
					<h4 className={styles.date}>{articleDate}</h4>
					<div className={styles.social}>
						<a href={`https://www.facebook.com/sharer/sharer.php?u=${pageLink}`}>
							<Image src="/blog/facebook.png" loading="lazy" width="25" height="25" alt="socials-logo" />
						</a>
						<a href={`https://t.me/share/url?url=${pageLink}&text=${title}`}>
							<Image src="/blog/telegram.png" loading="lazy" width="25" height="25" alt="socials-logo" />
						</a>
						<a href={`whatsapp://send?text=${pageLink}`}>
							<Image src="/blog/whats.png" loading="lazy" width="25" height="25" alt="socials-logo" />
						</a>
						<a href={`https://www.twitter.com/share?url=${pageLink}`}>
							<Image src="/blog/twitter.png" loading="lazy" width="25" height="25" alt="socials-logo" />
						</a>
					</div>
					<article className={styles.content} dangerouslySetInnerHTML={{ __html: `${article.replace(imgRegExp, '<img loading="lazy"')}` }} />
				</div>
			</section>
			{/* <Link href="/" className={styles["footer-back"]} /> */}
		</BlogLayout>
	);
}

export async function getServerSideProps({ req, query, res }) {
	let params = "";

	if (req.headers.host === "localhost:3000" || req.headers.host === "dev.bgrem.ai") {
		params = `&publicationState=preview`;
	}

	const { data } = await axios.get(`https://cms.bgrem.ai/api/blogs?populate=*${params}`);

	const articleInfo = data.data.find((item) => {
		return item.attributes.url_name === query.article;
	});

	if (articleInfo === undefined) {
		res.setHeader("location", "/blog");
		res.statusCode = 302;
		res.end();
		return;
	}

	return {
		props: {
			articleInfo: articleInfo,
		},
	};
}
